import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmOrganizationsRoute: InvariantJiraRoute = {
	name: 'csm-organizations',
	path: '/jira/customer-service-management/organizations',
	exact: true,
};
